/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { CustomerSubscriptionDescription } from "../../models/customer-subscription-description";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface UpsertCustomerSubscriptionDescription$Params {
  body: CustomerSubscriptionDescription;
}

export function upsertCustomerSubscriptionDescription(
  http: HttpClient,
  rootUrl: string,
  params: UpsertCustomerSubscriptionDescription$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, upsertCustomerSubscriptionDescription.PATH, "put");
  if (params) {
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "*/*", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    }),
  );
}

upsertCustomerSubscriptionDescription.PATH = "/dashboard/customers/{customerId}/descriptions/{subscriptionId}";
